import { Component, OnInit } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { UtilService } from '../../util/util.service';
import { AuthService } from '../../auth/auth.service';
import { NotificationService } from '../../notification/notification.service';
import { LocalStorageService } from '../../storage/local-storage.service';

@Component({
  selector: 'wl-unauthenticated',
  templateUrl: 'unauthenticated-psfy.component.html',
  styleUrls: ['unauthenticated-psfy.component.less'],
    standalone: false
})
export class UnauthenticatedComponent {
  //implements OnInit {

  public _utilService: UtilService;
  public _authService: AuthService;
  public _notifyService: NotificationService;
  public _translateService: TranslateService;

  public showTenant: boolean;
  public tenant: string = '';

  public constructor(
    authService: AuthService,
    utilService: UtilService,
    notifyService: NotificationService,
    translateService: TranslateService
  ) {
    this._authService = authService;
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translateService = translateService;
    this.showTenant = false;
  }

  ngOnInit() {
    this.tenant = this._authService.getTenant();
  }

  public login(): void {
    if (this._utilService.isNotNullEmptyOrWhitespace(this.tenant)) {
      this._authService.setTenant(this.tenant);

      this._authService.sendUserToPsfyIdpLogin();
    } else {
      //let message: string = this._translateService.instant("shared.container.unauthenticated.component.tenant-not-valid-message");
      //this._notifyService.warn(message);
      this._authService.sendUserToPsfyIdpLogin();
    }
  }

  public toggleShowTenant() {
    this.showTenant = !this.showTenant;
  }
}
